import React, {Component} from 'react';
import {Link} from 'react-router';
import formatNumbers from 'util/formatNumbers';
import {Button, Col, ControlLabel, FormControl, FormGroup, Modal, Row} from 'react-bootstrap';
import {v4 as uuidv4} from 'uuid';
import classNames from 'classnames';
import RemoveModalDialog from 'shared/RemoveModalDialog';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import FaCommenting from 'react-icons/lib/fa/commenting';
import HistoryDataModal from 'shared/HistoryDataModal';
import FaEdit from 'react-icons/lib/fa/edit';
import config from '../../../config';
import FaCheckCircle from 'react-icons/lib/fa/check-circle-o';
import FaCircleRemove from 'react-icons/lib/fa/times-circle-o';
import {
  base64ToHex,
  actionsFormatter,
  customFormatter,
  dateFormatter,
  getFieldByPathFormatter,
  prepareSelectOptionsList,
  priceFormatter,
} from 'util/Utils';

import {ADD_SELECTED_PRODUCTS, REMOVE_SELECTED_PRODUCTS,} from 'actions/actionTypes';
import TableCustomEditor from 'shared/table/TableCustomEditor';
import CustomTableHeaderCheckbox from 'shared/table/CustomTableHeaderCheckbox';
import _ from 'lodash';

class AdminProductListTable extends Component {
  static get contextTypes() {
    return {
      router: React.PropTypes.object.isRequired,
    };
  }

  constructor(props) {
    super(props);
    this.editProduct = this.editProduct.bind(this);
    this.updateProduct = this.updateProduct.bind(this);
    const { EnableEditShopifyListingPrice = false } = this.props.appData.FeatureFlags || {}
    this.isEditShopifyListingPriceEnabled = EnableEditShopifyListingPrice

    this.focusAreasOptionsList = _.map(this.props.focusAreas.data, function (item, key) {
      return { value: item.Name, label: item.Name };
    });
    this.state = {
      historyDataModalVisible: false,
      showModal: false,
      perPage: config.table.numberPerPage,
      currentRecord: {},
      currentProductItemRecord: {},
      editedProduct: {}
    };
    // this.allSellersOptionsList = prepareSelectOptionsList(this.props.allSellersList.data, {
    //     label: 'DisplayName',
    //     value: '_id'
    // })
    // this.allSellersOptionsList.unshift({label: 'All', value: 'all'});
  }
  customActionsFormatter(cell, row) {
    const menuItemsMap = [];
    const {ChangeLog = []} = row;

    if (!row.ShopifyProductID.includes('temporary')) {
      menuItemsMap.push({
        onClick: (row) => {
          const linkFormat = config.getEnvironment().shopify.productUrlTemplate;

          window.open(linkFormat.replace('[link_value]', row['ShopifyProductID']), '_blank', 'noreferrer');
        },
        label: 'Shopify Link',
      });
    }

    if (ChangeLog.length) {
      menuItemsMap.push({
        onClick: (row) => {
          this.setState({
            currentRecord: _.extend({}, row, {currentField: 'ChangeLog', modalTitle: 'Change Log'}),
            historyDataModalVisible: true
          });
        },
        label: 'Log',
      });
    }

    if (_.size(_.intersection(this.props.userReducer.user.Roles, ['Administrator'])) > 0) {
      menuItemsMap.push({
        onClick: (row) => {
          this.props.showRemoveDialog(row);
        },
        label: 'Delete',
      });
    }

    return actionsFormatter.call(this, cell, row, { menuItemsMap });
  }
  modalTableCustomActionsFormatter(cell, row, extra) {
    var menuItemsMap = [];
    if (
      _.size(_.intersection(this.props.userReducer.user.Roles, ['Administrator'])) > 0 &&
      row.ProductItemStatus == 'Pending'
    ) {
      menuItemsMap.push({
        onClick: (row) => {
          this.setState({ currentProductItemRecord: row, removeProductItemModalVisible: true });
        },
        label: 'Delete',
      });
    }

    return actionsFormatter.call(this, cell, row, { menuItemsMap });
  }
  componentWillReceiveProps(nextProps) {
    if (_.size(nextProps.allSellersList.data) !== _.size(this.props.allSellersList.data)) {
      this.allSellersOptionsList = prepareSelectOptionsList(nextProps.allSellersList.data, {
        label: 'DisplayName',
        value: '_id',
      });
    }
  }

  editProduct(row) {
    this.context.router.push(`/admin/product/${encodeURIComponent(row._id)}/edit`);
  }
  getProductByID(row) {
    console.log('getProductByID', row);

    var methodData = {
      endpoint: '/products',
      not_display_success_message: true,
    };
    return this.props
      .makeRequest({ lookup: ['CommentSentByUserID'], recordIDs: [row._id] }, methodData)
      .then(function (response) {
        return _.get(response, 'data.data.0', {});
      })
      .catch((err) => {});
  }
  getTransactionsData() {
    var queryParams = { ProductID: _.get(this.state.currentRecord, '_id') },
      self = this;
    if (_.get(this.state, 'currentRecord.OrderNumberOrID').length > 7) {
      queryParams.OrderIDs = [_.get(this.state, 'currentRecord.OrderNumberOrID')];
    } else {
      queryParams.OrderNumber = _.get(this.state, 'currentRecord.OrderNumberOrID');
    }
    var methodData = {
      endpoint: '/transactions',
      not_display_success_message: true,
    };

    return this.props
      .makeRequest(queryParams, methodData)
      .then(function (response) {
        if (!_.get(response, 'data.data', []).length) {
          return self.props.displayMessage({
            messageType: 'warning',
            messageCode: 'Sorry, order not found by this ID or number',
          });
        }
        var ProductItemsToRestock = [],
          restockedItems = [],
          ProductItemsToUpdate = _.cloneDeep(_.get(self.state.currentRecord, 'ProductItems', []));
        _.forEach(_.get(response, 'data.data', []), (item) => {
          /* can also check if product include Restocking product item change log*/
          if (
            _.get(
              item,
              'SaleData.LinkedProductItem.LinkedProductItemCustomData.ProductItemRestockedBy'
            )
          ) {
            restockedItems.push(_.get(item, 'SaleData.LinkedProductItem.ProductItemSKU'));
          } else if (
            _.get(item, 'SaleData.LinkedProductItem.ProductItemSKU') &&
            (_.find(_.get(item, 'ChangeLog', []), (changeLog) => {
              return (
                _.get(changeLog, 'FieldChanged') == 'Status' &&
                _.get(changeLog, 'To') == 'Restocked'
              );
            }) ||
              item.Status == 'Restocked')
          ) {
            restockedItems.push(_.get(item, 'SaleData.LinkedProductItem.ProductItemSKU'));
          } else {
            if (_.get(item, 'SaleData.LinkedProductItem.ProductItemSKU')) {
              ProductItemsToRestock.push(_.get(item, 'SaleData.LinkedProductItem.ProductItemSKU'));

              console.log('ProductItemsToRestock', ProductItemsToRestock);
              var foundItemIndex = _.findIndex(ProductItemsToUpdate, {
                ProductItemSKU: _.get(item, 'SaleData.LinkedProductItem.ProductItemSKU'),
              });
              if (foundItemIndex !== -1) {
                ProductItemsToUpdate[foundItemIndex].RestockProductItem = item;
              }
            }
          }
        });
        console.log('ProductItemsToRestock', ProductItemsToRestock);
        if (!ProductItemsToRestock.length) {
          var message = '';
          if (restockedItems.length) {
            message =
              'Sorry, no SKU to restock  found. Items with SKU ' +
              restockedItems.join(', ') +
              ' already restocked';
          } else {
            message = 'Sorry, no matching SKU is found for this order';
          }
          return self.props.displayMessage({
            messageType: 'warning',
            messageCode: message,
          });
        }
        self.setState({
          currentProductItemRecord: {},
          currentRecord: { ...self.state.currentRecord, ProductItems: ProductItemsToUpdate },
        });
      })
      .catch((err) => {});
  }
  updateProduct(data) {
    console.log('in update product', data);

    var objectData = {},
      self = this;
    // if (!_.isUndefined(data.event)) { /* for checkboxes*/
    //     //console.log('event', event.target.getAttribute('value'));
    //     if (data.cellName == 'Status') {
    //         objectData[data.cellName] = data.event.target.checked ? 'Active' : 'Inactive';
    //     }
    // } else {
    //  objectData[data.cellName] = data.row[data.cellName];
    // }
    var messageCode = 'recordUpdated';
    if (data.cellValue && data.cellName == 'ProductItemLocation') {
      var ProductItemsToUpdate = _.cloneDeep(_.get(this.state.currentRecord, 'ProductItems', []));
      console.log('cloned', ProductItemsToUpdate);
      var foundItemIndex = _.findIndex(ProductItemsToUpdate, { itemID: data.row.itemID });
      if (foundItemIndex !== -1) {
        console.log('ProductItemsToUpdate[foundItemIndex]', ProductItemsToUpdate[foundItemIndex]);
        console.log('data.cellValue', data.cellValue);
        if (ProductItemsToUpdate[foundItemIndex].ProductItemLocation !== data.cellValue) {
          ProductItemsToUpdate[foundItemIndex].ProductItemLocation = data.cellValue;
          objectData.ProductItemsToUpdate = ProductItemsToUpdate;
          objectData.ProductItemToUpdate = ProductItemsToUpdate[foundItemIndex];
          objectData.ProductItemToUpdate.FieldToUpdate = 'ProductItemLocation';
        }

        messageCode = 'Item location updated';
      }
    } else if (data.cellName == 'RestockProductItem') {
      var ProductItemsToUpdate = _.cloneDeep(_.get(this.state.currentRecord, 'ProductItems', []));

      var foundProductItemIndex = _.findIndex(ProductItemsToUpdate, { itemID: data.row.itemID });
      if (foundProductItemIndex !== -1) {
        console.log('data.cellValue', data.cellValue);
        var baseNumberSKUmatch = _.get(
          ProductItemsToUpdate[foundProductItemIndex],
          'ProductItemSKU'
        ).match(/^\d+\.\d+\.\d+$/);
        if (
          baseNumberSKUmatch &&
          ProductItemsToUpdate[foundProductItemIndex].ProductItemStatus == 'Pending'
        ) {
          ProductItemsToUpdate[foundProductItemIndex].ProductItemQuantity =
            _.get(ProductItemsToUpdate[foundProductItemIndex], 'ProductItemQuantity', 1) + 1;
        } else {
          ProductItemsToUpdate[foundProductItemIndex].ProductItemQuantity =
            _.get(ProductItemsToUpdate[foundProductItemIndex], 'ProductItemQuantity', 0) + 1;
        }
        ProductItemsToUpdate[foundProductItemIndex].ProductItemStatus = 'Pending';

        if (ProductItemsToUpdate[foundProductItemIndex].ProductItemQuantity == 1) {
          delete ProductItemsToUpdate[foundProductItemIndex].ProductItemQuantity;
        }
        console.log('RestockProductItem', ProductItemsToUpdate[foundProductItemIndex]);
        //   objectData.ProductItemsToUpdate = ProductItemsToUpdate
        objectData.ProductItemsToUpdate = _.map(ProductItemsToUpdate, (item) => {
          return { ...item, RestockProductItem: false }; /*remove RestockProductItem from objects*/
        });
        objectData.ProductItemToUpdate = objectData.ProductItemsToUpdate[foundProductItemIndex];
        objectData.ProductItemToUpdate.FieldToUpdate = 'RestockProductItem';
        objectData.ProductItemToUpdate.OrderID = _.get(
          data.row,
          'RestockProductItem.SaleData.OrderID'
        );
         messageCode = 'Product item restocked';
      }
    }
    objectData.currentVersionUpdatedAt = _.get(self.state.currentRecord, 'updatedAt');

    let endpoint = `/products/${encodeURIComponent(self.state.currentRecord._id)}`;

     if(self.props.appData.FeatureFlags.UseUpdate3PLItemHandler) {
      endpoint =  '/products/3pl';
      objectData = {
        productID: self.state.currentRecord._id,
        data:data,
        productItemToUpdate:objectData.ProductItemToUpdate
      };
    }
    return this.props
      .makeRequest(objectData, {
        type: 'patch',
        endpoint,
        messageData: { '#1#': 'Product' },
        messageCode: messageCode,
      })
      .then(function (res) {
        self.props.search({ page: self.props.currentPage + 1 });
        self.setState({
          currentRecord: {
            ...self.state.currentRecord,
            updatedAt: res.data.updatedAt,
            ProductItems: _.map(_.get(res.data, 'ProductItems', []), (item) => {
              return { ...item, itemID: uuidv4(), RestockProductItem: false };
            }),
          },
        });
        return true;
      })
      .catch((err) => {
        console.log('err', err);
        return Promise.reject(err);
      });
  }
  removeProductItem() {
    var objectData = {},
      self = this;
    var ProductItemsToUpdate = _.cloneDeep(_.get(this.state.currentRecord, 'ProductItems', []));
    var foundItemIndex = _.findIndex(ProductItemsToUpdate, {
      itemID: this.state.currentProductItemRecord.itemID,
    });
    if (foundItemIndex !== -1) {
      objectData.ProductItemsToRemove = [ProductItemsToUpdate[foundItemIndex]];
      objectData.ProductItemsToUpdate = ProductItemsToUpdate = [
        ...ProductItemsToUpdate.slice(0, foundItemIndex),
        ...ProductItemsToUpdate.slice(foundItemIndex + 1),
      ];
      objectData.currentVersionUpdatedAt = _.get(self.state.currentRecord, 'updatedAt');
    }
    let endpoint = `/products/${encodeURIComponent(self.state.currentRecord._id)}`;

    if(self.props.appData.FeatureFlags.UseUpdate3PLItemHandler) {
      endpoint =  '/products/3pl';
      objectData = {
        productID:self.state.currentRecord._id,
        productItemToRemove:objectData.ProductItemsToRemove[0]
      };
    }

    this.props
      .makeRequest(objectData, {
        type:self.props.appData.FeatureFlags.UseUpdate3PLItemHandler ? 'delete' : 'patch',
        endpoint: endpoint,
        messageCode: 'Product item removed',
      })
      .then(function (res) {
        console.log('ProductItemsToUpdate', ProductItemsToUpdate);
        self.setState({
          currentProductItemRecord: {},
          currentRecord: {
            ...self.state.currentRecord,
            updatedAt: res.data.updatedAt,
            ProductItems: ProductItemsToUpdate,
          },
        });

        self.props.search({ page: self.props.currentPage + 1 });
      })
      .catch((err) => {
        console.log('err', err);
      });
  }

  hideModal() {
    this.setState({ currentRecord: {}, historyDataModalVisible: false });
  }

  addCustomClass() {
    return 'center-align-table-column';
  }

  customLinkFormatter(cell, row) {
    if (config.checkAccessRights.call(this, { resources: ['products_edit'] })) {
      const featureFlags = this.props.appData.FeatureFlags

      return (
        <Link
          className=""
          to={{
            pathname: `/admin/product/${encodeURIComponent(row._id)}/edit`,
            state: { featureFlags }
          }}
        >{`${row.ProductName}`}</Link>
      );
    } else {
      return <span>{row.ProductName}</span>;
    }
  }

  displayCurrentScreenContent() {
    var self = this;
    const cellEditProp = {
      mode: 'click',
      // afterSaveCell: this.onAfterSaveCell.bind(this)
    };

    return (
      <div>
        {_.includes(['ProductItems'], this.state.currentRecord.currentField) && (
          <div>
            <BootstrapTable
              data={this.state.currentRecord.ProductItems}
              ref="table"
              hover={true}
              condensed={true}
              striped={true}
              cellEdit={cellEditProp}
            >
              <TableHeaderColumn
                dataField="ProductItemSKU"
                isKey={true}
                hidden={true}
                autoValue={true}
                hiddenOnInsert
              >
                Id
              </TableHeaderColumn>
              <TableHeaderColumn
                width="80px"
                columnClassName={'break-word'}
                editable={false}
                dataField="ProductItemSKU"
                dataAlign="left"
                formatExtraData={{ path: ['ProductItemSKU'] }}
                dataFormat={getFieldByPathFormatter}
              >
                SKU
              </TableHeaderColumn>
              <TableHeaderColumn
                width="60px"
                customEditor={{
                  getElement: self.displayCustomEditor,
                  customEditorParameters: { cellName: 'ProductItemLocation' },
                }}
                //   editable={ { type: 'textarea' } }

                dataField="ProductItemLocation"
                dataAlign="center"
                columnClassName={'break-word'}
                formatExtraData={{ path: ['ProductItemLocation'] }}
                dataFormat={getFieldByPathFormatter}
              >
                Location (click to edit))
              </TableHeaderColumn>
              <TableHeaderColumn
                width="60px"
                editable={false}
                dataFormat={customFormatter}
                dataField="ProductItemStatus"
                formatExtraData={{
                  path: ['getObject'],
                  format: (row) => {
                    return (
                      <div>
                        <span
                          style={{
                            position: 'relative',
                            top: 2,
                          }}
                        >
                          {_.get(row, 'ProductItemStatus', '')}
                        </span>

                        {_.get(row, 'RestockProductItem') && (
                          <div
                            style={{
                              position: 'relative',
                              color: 'orange',
                              top: 2,
                            }}
                          >
                            <Link
                              className="cursor-pointer"
                              onClick={() => {
                                var self = this;
                                if (this.state.pending) {
                                  return;
                                }
                                this.setState({ pending: true }, () => {
                                  this.updateProduct({
                                    row: row,
                                    cellName: 'RestockProductItem',
                                    cellValue: '',
                                  })
                                    .then(() => {
                                      this.setState({ pending: false });
                                    })
                                    .catch((err) => {
                                      this.setState({ pending: false });
                                    });
                                });
                              }}
                            >
                              Restock item
                            </Link>
                          </div>
                        )}
                      </div>
                    );
                  },
                }}
                dataAlign="center"
              >
                Status
              </TableHeaderColumn>
              <TableHeaderColumn
                width="30px"
                editable={false}
                dataFormat={customFormatter}
                dataField="ProductItemQuantity"
                formatExtraData={{
                  path: ['getObject'],
                  format: (row) => {
                    return _.get(row, 'ProductItemStatus') == 'Pending' ? (
                      <div>
                        <span
                          style={{
                            position: 'relative',
                            top: 2,
                          }}
                        >
                          {_.get(row, 'ProductItemQuantity', '1')}
                        </span>
                      </div>
                    ) : null;
                  },
                }}
                dataAlign="center"
              >
                Qty
              </TableHeaderColumn>
              <TableHeaderColumn
                width="50px"
                editable={false}
                dataField="CreatedAtDate"
                dataFormat={dateFormatter}
                formatExtraData={{ path: 'CreatedAtDate', format: 'MM/DD/YY' }}
                dataAlign="center"
              >
                Created
              </TableHeaderColumn>
              <TableHeaderColumn
                width="30px"
                editable={false}
                dataAlign="center"
                columnClassName={'actions-column'}
                dataFormat={this.modalTableCustomActionsFormatter.bind(this)}
              >
                Actions
              </TableHeaderColumn>
            </BootstrapTable>
            <Row className="left0">
              <Col md={12} sm={12} xs={12} className="top15 pleft0">
                {!_.get(this.state, 'currentRecord.displayRestockOrderForm', false) && (
                  <Button
                    className=" btn  btn-primary  "
                    type="button"
                    onClick={(e) => {
                      this.setState({
                        currentRecord: {
                          ...this.state.currentRecord,
                          ProductItems: _.map(
                            _.get(this.state.currentRecord, 'ProductItems', []),
                            (item) => {
                              return { ...item, RestockProductItem: false };
                            }
                          ),
                          displayRestockOrderForm: true,
                        },
                      });
                    }}
                  >
                    Restock
                  </Button>
                )}
                {_.get(this.state, 'currentRecord.displayRestockOrderForm', false) && (
                  <FormGroup className="top10">
                    <ControlLabel>Order Number or ID</ControlLabel>
                    <FormControl
                      type="text"
                      onChange={(e) => {
                        this.setState({
                          currentRecord: {
                            ...this.state.currentRecord,
                            OrderNumberOrID: e.target.value,
                          },
                        });
                      }}
                      defaultValue={this.state.currentRecord.OrderNumberOrID}
                    />
                    <Button
                      className="pull-right btn  btn-primary top10 "
                      type="button"
                      disabled={_.get(this.state, 'currentRecord.OrderNumberOrID', '') == ''}
                      onClick={(e) => {
                        this.setState({
                          currentRecord: {
                            ...this.state.currentRecord,

                            displayRestockOrderForm: false,
                          },
                        });
                        this.setState({ pending: true }, () => {
                          this.getTransactionsData()
                            .then(() => {
                              this.setState({ pending: false });
                            })
                            .catch((err) => {
                              this.setState({ pending: false });
                            });
                        });
                      }}
                    >
                      Submit
                    </Button>
                  </FormGroup>
                )}
              </Col>
            </Row>
            {this.state.pending && <div className="pending-box"></div>}
          </div>
        )}
        {_.includes(['TrackingNumbers'], this.state.currentRecord.currentField) && (
          <div>
            <BootstrapTable
              data={this.state.currentRecord.TrackingNumbers}
              ref="table"
              hover={true}
              condensed={true}
              striped={true}
            >
              <TableHeaderColumn
                dataField="_id"
                isKey={true}
                hidden={true}
                autoValue={true}
                hiddenOnInsert
              >
                Id
              </TableHeaderColumn>
              <TableHeaderColumn
                width="60px"
                columnClassName={'break-word'}
                dataField="TrackingNumber"
                dataAlign="center"
              >
                Number
              </TableHeaderColumn>
              <TableHeaderColumn
                width="60px"
                editable={false}
                dataFormat={customFormatter}
                dataField="Disposition"
                formatExtraData={{
                  path: ['getObject'],
                  format: (row) => {
                    return _.get(
                      _.find(config.dispositionOptions, { value: row.Disposition }),
                      'label',
                      ''
                    );
                  },
                }}
                dataAlign="center"
              >
                Disposition
              </TableHeaderColumn>
              <TableHeaderColumn width="60px" dataField="InvoiceCost" dataAlign="center">
                Invoice Cost
              </TableHeaderColumn>
              <TableHeaderColumn
                width="60px"
                columnClassName={'break-word'}
                dataField="UserNotes"
                dataAlign="center"
              >
                User Notes
              </TableHeaderColumn>
            </BootstrapTable>
          </div>
        )}
      </div>
    );
  }


  stringToLinkFormatter(cell, row, extra) {
    return (
      <a target="_blank" href={row[extra]}>
        Link
      </a>
    );
  }

  onRowSelect(row, isSelected, e) {
    var actionName = isSelected ? ADD_SELECTED_PRODUCTS : REMOVE_SELECTED_PRODUCTS;
    this.props.dispatchAction([row], actionName);
  }
  onAllRowSelect(isSelected, rows) {
    console.log('isSelected', rows);
    var actionName = isSelected ? ADD_SELECTED_PRODUCTS : REMOVE_SELECTED_PRODUCTS;
    this.props.dispatchAction(rows, actionName);
  }
  customMultiSelect(props) {
    if (!_.isUndefined(this.refs.table)) {
      var rowIDs = _.map(this.refs.table.state.data, function (row, key) {
        return row._id;
      });
    }
    var { type, checked, disabled, onChange, rowIndex } = props;

    if (!_.isUndefined(rowIDs) && rowIndex !== 'Header') {
      checked = _.includes(this.props.adminProducts.selectedProducts, rowIDs[rowIndex]);
    }

    /*
     * If rowIndex is 'Header', means this rendering is for header selection column.
     */
    if (rowIndex === 'Header') {
      return (
        <div className="checkbox-personalized">
          <CustomTableHeaderCheckbox {...props} />
          <label htmlFor={'checkbox' + rowIndex}>
            <div className="check"></div>
          </label>
        </div>
      );
    } else {
      return (
        <div className="checkbox-personalized">
          <input
            type={type}
            name={'checkbox' + rowIndex}
            id={'checkbox' + rowIndex}
            checked={checked}
            disabled={disabled}
            onChange={(e) => onChange(e, rowIndex)}
          />
          <label htmlFor={'checkbox' + rowIndex}>
            <div className="check"></div>
          </label>
        </div>
      );
    }
  }
  closeModal() {
    this.setState({
      showModal: false,
      currentRecord: {},
    });
  }

  displayCustomEditor = (onUpdate, props) => {
     return <TableCustomEditor onUpdate={this.updateProduct} {...props} />;
  };
  customPriceFormatter(cell, row, fieldName) {
    let percent = 'n/a';

    if (row.OriginalSellerPrice) {
      percent = Math.round(100 - formatNumbers.toFixed(cell / row.OriginalSellerPrice, 2) * 100);
    }

    const formattedNumber = formatNumbers.formatMoney(cell, {precision: cell % 1 == 0 ? 0 : 2});
      return <div><span
        className={classNames({
          'cursor-pointer': !this.state.editedProduct.productSaved
        })}
        onClick={()=> {
          if(this.state.editedProduct.productSaved) return;
          this.setState({editedProduct:{...row, fieldToEdit: fieldName}});
      }} >
      {formattedNumber}</span>
        {percent > 1 &&
          <p style={{fontSize:15, color:'orange'}}>-{percent}%</p>
        }
        {percent < 0 &&
          <p style={{fontSize:15, color:'red'}}>-{percent}%</p>
        }
      </div>;
      }

  editablePriceFormatter(cell, row) {
    const editedProduct = this.state.editedProduct;

    if (editedProduct._id == row._id && editedProduct.fieldToEdit == 'Price') {
      const editedPrice = _.isUndefined(editedProduct.updatedPrice) ? editedProduct.Price : editedProduct.updatedPrice;

      if(editedProduct.productSaved) {
        return this.customPriceFormatter(editedPrice, row, 'Price');
      }

        return <span>
       {editedProduct.pending &&
         <div className="pending-box"></div>
       }
      <input
        className={' form-control cell-edit-input'}
        style={{}}
        onClick={(e) => {
          e.stopPropagation();
        }}
        type='text'
        value={editedPrice}
        onChange={({target: {value}})=> {
           this.setState({editedProduct: {
            ...this.state.editedProduct,
              updatedPrice:value }}
          );
        }}/>
      {editedPrice != row.Price &&
        <button
          className='btn btn-primary cell-edit-button'
          disabled={this.state.editedProduct.pending}
          onClick={() => {
            this.onProductDataChange(row, {Price:editedPrice}, 'Price');
          }}>
          Save
        </button>
      }
    </span>;
    }else {
      return this.customPriceFormatter(cell, row, 'Price');
    }
  }

  editableShopifyListingPriceFormatter(cell, row) {
    const editedProduct = this.state.editedProduct;

    if (editedProduct._id == row._id && editedProduct.fieldToEdit == 'ShopifyListingPrice') {
      const editedPrice = _.isUndefined(editedProduct.updatedShopifyListingPrice) ? editedProduct.ShopifyListingPrice : editedProduct.updatedShopifyListingPrice;

      if(editedProduct.productSaved) {
        return this.customPriceFormatter(editedPrice, row, 'ShopifyListingPrice');
      }

        return <span>
       {editedProduct.pending &&
         <div className="pending-box"></div>
       }
      <input
        className={' form-control cell-edit-input'}
        style={{}}
        onClick={(e) => {
          e.stopPropagation();
        }}
        type='text'
        value={editedPrice}
        onChange={({target: {value}})=> {
           this.setState({editedProduct: {
            ...this.state.editedProduct,
              updatedShopifyListingPrice:value }}
          );
        }}/>
      {editedPrice != row.ShopifyListingPrice &&
        <button
          className='btn btn-primary cell-edit-button'
          disabled={this.state.editedProduct.pending}
          onClick={() => {
            this.onProductDataChange(row, { ShopifyListingPrice: editedPrice }, 'ShopifyListingPrice');
          }}>
          Save
        </button>
      }
    </span>;
    }else {
      return this.customPriceFormatter(cell, row, 'ShopifyListingPrice');
    }
  }

  onProductDataChange(row, dataToSave, fieldName) {
    const self = this;
    const updatedValue = dataToSave[fieldName]

    if (updatedValue.trim() == '' || isNaN(updatedValue)) {
     return this.props.displayMessage({
        messageType: 'warning',
        messagePosition: 'bc',
        messageCode: 'Please, specify a valid price amount'
      });
    }

    dataToSave[fieldName] = formatNumbers.unformat(updatedValue);

    if (dataToSave[fieldName] == row[fieldName]) {
      return false;
    }

    self.setState({editedProduct: {
        ...this.state.editedProduct,
        pending:true
    }});
    self.props.makeRequest(dataToSave, {
      endpoint: `/products/${encodeURIComponent(self.state.editedProduct._id)}`,
      type: 'patch',
    }).then(response => {
      self.setState({editedProduct: {
          ...this.state.editedProduct,
          pending:false,
          productSaved:true
        }});
      self.props.displayMessage({
        messageCode: 'Product updated',
      });
      self.props.search({doNotWaitForResponse:true, page: self.props.currentPage + 1 }).then(()=>{
        self.setState({editedProduct: {}});
      });
    }).catch(err => {
      self.setState({editedProduct: {}});
    });
  }
  render() {
    var self = this;
     const selectRowProp = {
      mode: 'checkbox',
      columnWidth: '29px',
      onSelect: this.onRowSelect.bind(this),
      onSelectAll: this.onAllRowSelect.bind(this),
      customComponent: this.customMultiSelect.bind(this),
    };

    return (
      <div className="databases-table"  >
        <BootstrapTable
          data={this.props.data}
          ref="table"
          containerStyle={ { width: '0%' } }
          selectRow={selectRowProp}
          remote={true}
          hover={true}
          condensed={true}
          striped={true}
          options={{
            ...config.bootstrapTableOptions,
            onSortChange: this.props.onSortChange,
          }}
        >
          <TableHeaderColumn
            width="150px"
            dataField="ProductName"
            dataAlign="center"
            dataFormat={this.customLinkFormatter.bind(this)}
            dataSort={true}
          >
            Title
          </TableHeaderColumn>
          <TableHeaderColumn
            width="150px"
            dataField="_id"
            isKey={true}
            hidden={true}
            autoValue={true}
            hiddenOnInsert
          >
            Id
          </TableHeaderColumn>

          <TableHeaderColumn width="90px" formatExtraData={ {path: ['Price']}  }
                             dataFormat={(cell, row) => {
                               if (this.isEditShopifyListingPriceEnabled) {
                                 return priceFormatter(cell, row, { path: ['Price'] });
                               } else {
                                 return self.editablePriceFormatter(cell, row);
                               }
                             } }
                             columnClassName={ 'editable-table-cell' }
                             dataField='Price' dataAlign="center" dataSort={true}>Price</TableHeaderColumn>
          <TableHeaderColumn
            width="90px"
            dataFormat={(cell, row) => {
              if (this.isEditShopifyListingPriceEnabled) {
                return self.editableShopifyListingPriceFormatter(cell, row);
              } else {
                return priceFormatter(cell, row, { path: ['ShopifyListingPrice'] });
              }
            }}
            formatExtraData={{ path: ['ShopifyListingPrice'] }}
            dataField="ShopifyListingPrice"
            dataAlign="center"
            dataSort={true}
          >
            Shopify L. P.
          </TableHeaderColumn>

          <TableHeaderColumn
            width="60px"
            formatExtraData={{ path: ['OriginalSellerPrice'] }}
            dataFormat={priceFormatter}
            dataField="OriginalSellerPrice"
            dataAlign="center"
            dataSort={true}
          >
            Starting Base Price
          </TableHeaderColumn>

          <TableHeaderColumn
            width="50px"
            ref="statusCol"
            columnClassName={this.addCustomClass}
            dataField="Status"
            dataFormat={customFormatter}
            dataAlign="center"
            dataSort={true}
            formatExtraData={{
              path: ['getObject'],
              format: (row) => {
                return (
                  <div>
                    {(_.size(_.get(row, 'TrackingNumbers', [])) > 0 && (
                      <Link
                        className="cursor-pointer"
                        onClick={() => {
                          this.setState({
                            currentRecord: _.extend({}, row, {
                              TrackingNumbers: _.map(_.get(row, 'TrackingNumbers', []), (item) => {
                                return { ...item, itemID: uuidv4() };
                              }),
                              currentField: 'TrackingNumbers',

                              modalTitle: 'Tracking Numbers',
                            }),
                            showModal: true,
                          });
                        }}
                      >

                      <div style={{ position: 'relative', top: 2}}>
                        {_.get(row, 'Status', '') == 'Active' ? <FaCheckCircle style={{fontSize: 34, color: 'green'}} /> : <FaCircleRemove style={{fontSize: 34, color: 'gray'}} /> }
                      </div>

                      </Link>
                    )) || (
                      <div style={{ position: 'relative', top: 2}}>
                      {_.get(row, 'Status', '') == 'Active' ? <FaCheckCircle style={{fontSize: 34, color: 'green'}} /> : <FaCircleRemove style={{fontSize: 34, color: 'gray'}} /> }
                      </div>
                    )}


                  </div>
                );
              },
            }}
          >
            Status
          </TableHeaderColumn>
          {/*<TableHeaderColumn width="70px" dataAlign="center" dataField='MetroArea'*/}
          {/*dataSort={true}>Metro Area</TableHeaderColumn>*/}
          {/*<TableHeaderColumn width="70px" dataField='ZipCode' dataAlign="center" dataSort={true}>ZipCode</TableHeaderColumn>*/}
          <TableHeaderColumn width="50px" dataField="Condition" dataAlign="center" dataSort={true}>
            Condition
          </TableHeaderColumn>
          <TableHeaderColumn
            width="60px"
            dataField="OriginalPrice"
            dataAlign="center"
            formatExtraData={{ path: ['OriginalPrice'] }}
            dataFormat={priceFormatter}
            dataSort={true}
          >
            MSRP
          </TableHeaderColumn>
          <TableHeaderColumn
            width="70px"
            columnClassName={'break-word'}
            tdStyle={{ whiteSpace: 'normal' }}
            thStyle={{ whiteSpace: 'normal' }}
            dataField="SellerAndPickupNumber"
            dataAlign="center"
            formatExtraData={{ path: ['SellerAndPickupNumber'] }}
            dataFormat={getFieldByPathFormatter}
            dataSort={true}
          >
            Seller
          </TableHeaderColumn>
          <TableHeaderColumn
            width="60px"
            dataField="Markets.0.MarketName"
            dataFormat={customFormatter}
            formatExtraData={{
              path: ['getObject'],
              format: (row) => {
                return (
                  <div>
                    <span style={{ position: 'relative', top: 2 }}>
                      {_.get(row, 'Markets.0.MarketName', '')}
                    </span>

                    {_.get(row, 'ProductItems.0.ProductItemStatus') ? (
                      <div
                        style={{
                          position: 'relative',
                          color: 'orange',
                          top: 2,
                        }}
                      >
                        <Link
                          className="cursor-pointer"
                          onClick={() => {
                            this.setState({
                              currentRecord: _.extend({}, row, {
                                ProductItems: _.map(_.get(row, 'ProductItems', []), (item) => {
                                  return { ...item, itemID: uuidv4() };
                                }),
                                currentField: 'ProductItems',

                                modalTitle:
                                  _.get(row, 'ProductItems.0.ProductItemSKU') +
                                  ' Listing and Locations',
                              }),
                              showModal: true,
                            });
                          }}
                        >
                          Multiple
                        </Link>
                      </div>
                    ) : (
                      <span>
                        {' '}
                        {_.get(row, 'LocationInWarehouse', false) && (
                          <div
                            style={{
                              position: 'relative',
                              color: 'orange',
                              top: 2,
                            }}
                          >
                            {' '}
                            <div style={{}}>{_.get(row, 'LocationInWarehouse', '')}</div>{' '}
                          </div>
                        )}
                      </span>
                    )}
                  </div>
                );
              },
            }}
            dataAlign="center"
          >
            Location
          </TableHeaderColumn>
          <TableHeaderColumn
            width="60px"
            dataField="Markets.0.MarketName"
            dataFormat={customFormatter}
            formatExtraData={{
              path: ['getObject'],
              format: (row) => {
                return (
                  <div>
                    {row.ShopifyListingStatus}
                  </div>
                );
              },
            }}
            dataAlign="center"
          >
            Processing Status
          </TableHeaderColumn>
          <TableHeaderColumn
            width="60px"
            dataField="CreatedByUserName"
            dataFormat={customFormatter}
            formatExtraData={{
              path: ['getObject'],
              format: (row) => {
                var ProductEdited = _.find(_.get(row, 'ChangeLog', []), function (log) {
                  if (_.get(log.CustomData, 'ProductEdited')) {
                    return true;
                  }
                });
                return (
                  <div>
                    <span style={{ position: 'relative', top: 2 }}>
                      {_.get(row, 'CreatedByUserName', '')}
                    </span>
                    {_.get(row, 'MetaData.OriginalProductCreatedAt', false) ? (
                      <div
                        style={{
                          position: 'relative',
                          color: 'orange',
                          top: 2,
                        }}
                      >
                        {' '}
                        {_.get(row, 'PrelistingFinalizedByUserName', false) ? (
                          <div style={{}}>{_.get(row, 'PrelistingFinalizedByUserName', '')}</div>
                        ) : (
                          <div style={{}}>{_.get(row, 'CreatedByUserName', '')}</div>
                        )}
                      </div>
                    ) : (
                      <div></div>
                    )}

                    {ProductEdited && (
                      <span>
                        <FaEdit
                          // style={{color: '#00665E'}}
                          className={' top10 font-size-20 purple  left10'}
                        ></FaEdit>
                      </span>
                    )}
                    {_.get(row, 'Comments.0.CommentText') && (
                      <span>
                        <Link
                          className="cursor-pointer"
                          onClick={() => {
                            this.getProductByID(row).then((product) => {
                              console.log('product', product);
                              this.setState({
                                currentRecord: _.extend({}, product, {
                                  currentField: 'Comments',
                                  modalTitle: 'Internal Notes',
                                }),
                                historyDataModalVisible: true,
                              });
                            });
                          }}
                        >
                          {' '}
                          <FaCommenting
                            className={' top10 font-size-20 purple  left10'}
                          ></FaCommenting>
                        </Link>
                      </span>
                    )}
                  </div>
                );
              },
            }}
            dataAlign="center"
          >
            Created By
          </TableHeaderColumn>
          <TableHeaderColumn
            width="70px"
            dataField="createdAt"
            dataAlign="center"
            dataFormat={dateFormatter}
            formatExtraData={{ name: 'createdAt', format: 'MM/DD/YY' }}
            dataSort={true}
          >
            Create date
          </TableHeaderColumn>
          <TableHeaderColumn
            width="70px"
            dataField="FirstProductTransactionRecord.SaleData.TimeToSell"
            dataAlign="center"
            dataFormat={getFieldByPathFormatter}
            formatExtraData={{ path: 'FirstProductTransactionRecord.SaleData.TimeToSell' }}
            dataSort={true}
          >
            Days To Sell
          </TableHeaderColumn>
          <TableHeaderColumn
            width="35px"
            dataField="ProductVariants.0.Quantity"
            dataAlign="center"
            formatExtraData={{ path: ['ProductVariants', 0, 'Quantity'] }}
            dataFormat={getFieldByPathFormatter}
            dataSort={true}
          >
            Available Qty
          </TableHeaderColumn>
          <TableHeaderColumn
            width="35px"
            dataField="SoldQuantity"
            dataAlign="center"
            formatExtraData={{ path: ['SoldQuantity'] }}
            dataFormat={getFieldByPathFormatter}
          >
            Sold Qty
          </TableHeaderColumn>
          {/*<TableHeaderColumn width="35px" dataField='SaleTransactions' dataAlign="center"*/}
          {/*formatExtraData={ {path:[  'getObject']  , format: (row)=> {*/}
          {/*return _.size(_.get(row,  'SaleTransactionRecords',[]))*/}
          {/*}}}*/}
          {/*dataFormat={ customFormatter } dataSort={false}>SaleTransactions</TableHeaderColumn>*/}
          <TableHeaderColumn
            width="60px"
            dataAlign="center"
            columnClassName={'actions-column'}
            dataFormat={this.customActionsFormatter.bind(this)}
          >
            Actions
          </TableHeaderColumn>
        </BootstrapTable>
        <HistoryDataModal
          data={this.state.currentRecord}
          hideModal={this.hideModal.bind(this)}
          show={this.state.historyDataModalVisible}
        ></HistoryDataModal>

        <Modal
          onExited={this.closeModal.bind(this)}
          show={this.state.showModal}
          onHide={(e) => this.setState({ showModal: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title>{_.get(this.state.currentRecord, 'modalTitle', '')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>{this.displayCurrentScreenContent()}</Modal.Body>
        </Modal>
        <RemoveModalDialog
          show={this.state.removeProductItemModalVisible}
          removeRecord={(e) => {
            this.setState({ removeProductItemModalVisible: false });
            this.removeProductItem();
          }}
          modalTitleText={
            <span>
              <span>{'Are you sure you want to delete the SKU '}</span>
              <span className="text-bold">
                {_.get(this.state.currentProductItemRecord, 'ProductItemSKU', 'n/a')}
              </span>
              ?
            </span>
          }
          closeModal={(e) =>
            this.setState({ currentProductItemRecord: false, removeProductItemModalVisible: false })
          }
        ></RemoveModalDialog>
      </div>
    );
  }
}

export default AdminProductListTable;
